import dateFormat from "./DateFormat.service";
import { tryDate, tryNumber } from "./formatExcel.service";

export const saveAsExcelFile = (buffer, fileName) => {
    /*Función encargada de guardar y descargar el archivo Excel del reporte*/
    import('file-saver').then(FileSaver => {
        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xlsx';
        const data = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        FileSaver.default.saveAs(data, fileName + '_' + dateFormat(new Date()) + EXCEL_EXTENSION);
    });
}

export function excelExport(reporte, nombre) {
    /*Función encargada de construir el archivo Excel del reporte*/
    const DATE_NF = "dd/mm/yyyy"; 
    import("xlsx").then(xlsx => {
        const workbook = xlsx.utils.book_new();
        let formatedReport = []
        reporte.forEach(line => {
            for (const [key, value] of Object.entries(line)){
                const asDate = tryDate(line[key]);
                if (asDate) { line[key] = asDate; continue; }

                const asNum  = tryNumber(line[key]);
                if (asNum !== null) { line[key] = asNum; }
            }
            formatedReport.push(line)
        })
        const worksheet = xlsx.utils.json_to_sheet(formatedReport, {dense: true, cellDates: true});
        const data = worksheet;
        for (let R = 1; R < data.length; ++R) {
            const row = data[R];
            if (!row) continue;
            for (let C = 0; C < row.length; ++C) {
                const cell = row[C];
                if (!cell) continue;
                if (cell.t === "d") {
                    cell.z = DATE_NF;
                } 
                else if (cell.t === "n") {
                    if (Number.isInteger(cell.v)) {
                        cell.z = "0";              // entero: sin decimales
                    } else {
                        const decLen = ((cell.v + "")
                                        .split(".")[1] || "")       // "4232"
                                        .replace(/0+$/, "")         // quita ceros finales
                                        .length;                    // => 4

                        cell.z = "0." + "0".repeat(decLen); // "0.0000"
                    }
                }
                else{
                    if(cell.v === ""){
                        delete row[C];
                    }
                }
            }
        }
        xlsx.utils.book_append_sheet(workbook, worksheet, nombre)
        const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        saveAsExcelFile(excelBuffer, nombre)
    })
}